export const sirulaseema1 = {
  slug: "sirulaseema-1",
  name: "Sirulaseema-1",
  location: "South Hyderabad",
  approval: "MUDA layout permission and TG RERA registration",
  acreage: "Established community",
  status: "Project details available",
  logo: "/projects/sirulaseema-1/logo.png",
  hero: "/projects/sirulaseema-1/hero-aerial-layout.webp",
  summary:
    "An established plotted development with resort-style spaces, finished roads, landscaped entries, waterbody, and visible community amenities.",
  description:
    "Sirulaseema-1 is best shown as a completed proof point: real roads, entrance, greenery, amenity spaces, waterbody, and community infrastructure instead of only a layout graphic.",
  layoutImages: [{ src: "/projects/layouts/Sirulaseema1-Layout.webp", alt: "Sirulaseema-1 layout preview", label: "Layout preview" }],
  approvalImages: [
    { src: "/projects/sirulaseema-1/approval-phase-1.webp", alt: "Sirulaseema-1 MUDA and RERA approval details", label: "Phase 1 approval" },
    { src: "/projects/sirulaseema-1/approval-phase-2.webp", alt: "Sirulaseema-1 Phase 2 MUDA and RERA approval details", label: "Phase 2 approval" }
  ],
  featuredImages: [
    {
      src: "/projects/sirulaseema-1/overview-aerial-garden.webp",
      alt: "Sirulaseema-1 aerial garden and community view",
      title: "Completed community proof",
      copy: "The project should lead with real aerial and landscape photos because they show the finished community experience."
    },
    {
      src: "/projects/sirulaseema-1/entrance-gate.webp",
      alt: "Sirulaseema-1 entrance gate",
      title: "Entrance and arrival",
      copy: "The gate, arrival road, and landscaped edges create a stronger trust signal than a cropped approval graphic."
    },
    {
      src: "/projects/sirulaseema-1/blacktop-road.webp",
      alt: "Sirulaseema-1 blacktop internal road",
      title: "Road infrastructure",
      copy: "Blacktop road photos show site readiness and should anchor the infrastructure story."
    },
    {
      src: "/projects/sirulaseema-1/waterbody.webp",
      alt: "Sirulaseema-1 waterbody",
      title: "Waterbody and greenery",
      copy: "Lifestyle visuals make the project feel established, maintained, and easier to evaluate."
    }
  ],
  galleryImages: [
    ["/projects/sirulaseema-1/overview-aerial-garden.webp", "Aerial garden and community view"],
    ["/projects/sirulaseema-1/hero-aerial-layout.webp", "Aerial plotted community view"],
    ["/projects/sirulaseema-1/gazebo.webp", "Gazebo amenity"],
    ["/projects/sirulaseema-1/open-plots.webp", "Open plots view"],
    ["/projects/sirulaseema-1/entrance-gate.webp", "Entrance gate"],
    ["/projects/sirulaseema-1/curved-road.webp", "Curved internal road"],
    ["/projects/sirulaseema-1/blacktop-road.webp", "Blacktop internal road"],
    ["/projects/sirulaseema-1/garden-walkway.webp", "Landscaped walkway"],
    ["/projects/sirulaseema-1/play-area-landscape.webp", "Play area and landscape"],
    ["/projects/sirulaseema-1/avenue-road.webp", "Avenue road"],
    ["/projects/sirulaseema-1/waterbody.webp", "Waterbody"],
    ["/projects/sirulaseema-1/tree-lined-road.webp", "Tree-lined road"],
    ["/projects/sirulaseema-1/kids-play-area.webp", "Kids play area"],
    ["/projects/sirulaseema-1/community-building.webp", "Community building"],
    ["/projects/sirulaseema-1/arrival-road.webp", "Arrival road"]
  ],
  facts: [["Project", "Sirulaseema"], ["Phase", "1"], ["Asset", "Open plots"], ["Proof", "Completed site"]],
  amenities: ["Entrance gate", "Gazebo", "Blacktop roads", "Waterbody", "Kids play area", "Tree-lined avenues"]
};
